import React from 'react';
import {
  createGptSearchItem,
  GptSearchItem,
  GptSearchItemData,
  isGptSearchItem,
  SearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';
import { useGptSearchModules } from '../../Modules';

export interface GptSearchExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'object';
  rightOperand: { prompt: string };
}

export interface GptSearchExpressionModule extends ExpressionModule<GptSearchItemData> {
  toTokenData: (item: SearchItem) => GptSearchExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => GptSearchItem | undefined;
}

export const isGptSearchExpressionData = (token: TokenData<unknown>): token is GptSearchExpressionData => {
  return (
    token.leftOperand === 'Tickers.name' &&
    token.operator === 'object' &&
    typeof token.rightOperand === 'object' &&
    token.rightOperand != null &&
    'prompt' in token.rightOperand
  );
};

export const createGptSearchExpressionModule = (): GptSearchExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isGptSearchExpressionData(token)) return undefined;
      return createGptSearchItem(token.rightOperand.prompt);
    },
    toTokenData: item => {
      if (!isGptSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'object',
        rightOperand: { prompt: item.data.prompt },
      };
    },
  };
};

export const useGptSearchExpressionSearchModule = (): ExpressionSearchModule => {
  const gptsearchModule = useGptSearchModules();
  return React.useMemo(
    () => ({ ...gptsearchModule, expression: createGptSearchExpressionModule() }),
    [gptsearchModule],
  );
};
